import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-slate-900/95 backdrop-blur-sm shadow-lg"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img
              src="https://customer-assets.emergentagent.com/job_digital-studio-pro/artifacts/5kz5nw0k_logo_key4.png"
              alt="Web Key Studio"
              className="h-10 w-auto"
            />
            <span className="text-xl font-bold bg-gradient-to-r from-cyan-400 to-violet-500 bg-clip-text text-transparent">
              Web Key Studio
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection("hero")}
              className="text-white hover:text-cyan-400 transition-colors duration-300"
            >
              Accueil
            </button>
            <button
              onClick={() => scrollToSection("about")}
              className="text-white hover:text-cyan-400 transition-colors duration-300"
            >
              À propos
            </button>
            <button
              onClick={() => scrollToSection("projects")}
              className="text-white hover:text-cyan-400 transition-colors duration-300"
            >
              Réalisations
            </button>
            <button
              onClick={() => scrollToSection("services")}
              className="text-white hover:text-cyan-400 transition-colors duration-300"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="bg-gradient-to-r from-cyan-500 to-violet-500 text-white px-6 py-2 rounded-full hover:shadow-lg hover:shadow-cyan-500/25 transition-all duration-300 hover:scale-105"
            >
              Contact
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white hover:text-cyan-400 transition-colors duration-300"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 py-4 bg-slate-900/95 backdrop-blur-sm rounded-lg">
            <div className="flex flex-col space-y-4 px-4">
              <button
                onClick={() => scrollToSection("hero")}
                className="text-white hover:text-cyan-400 transition-colors duration-300 text-left"
              >
                Accueil
              </button>
              <button
                onClick={() => scrollToSection("about")}
                className="text-white hover:text-cyan-400 transition-colors duration-300 text-left"
              >
                À propos
              </button>
              <button
                onClick={() => scrollToSection("projects")}
                className="text-white hover:text-cyan-400 transition-colors duration-300 text-left"
              >
                Réalisations
              </button>
              <button
                onClick={() => scrollToSection("services")}
                className="text-white hover:text-cyan-400 transition-colors duration-300 text-left"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection("contact")}
                className="bg-gradient-to-r from-cyan-500 to-violet-500 text-white px-6 py-2 rounded-full hover:shadow-lg hover:shadow-cyan-500/25 transition-all duration-300 text-center"
              >
                Contact
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;